<div class="col-12 ">
    <div class="card">

        <app-list-layout [tableConfig]="tableConfig" [listItems]="listItems" [listService]="timeLineListService"
            [sortBy]="sortBy" (buttonActionSelected)="buttonActionSelected($event)"
            (updateCheckedValues)="checkedValGet =  $event" (rowActionSelected)="rowActionSelected($event)"
            (filterSelected)="filterSelected($event)" (sortSelected)="sortByPassedSort($event)"
            (searchTermChanged)="timeLineListService.searchTerm = $event"
            (resetListLayout) = "timeLineListService.resetListState($event)"
            (paginationSelected)="paginationUpdated(timeLineListService,$event)" [serviceData]="serviceData"
            (pageSizeSelected)="timeLineListService.pageSize = $event"></app-list-layout>

        <!-- <div *ngIf="showTitle" class="card-header border-0 "
            style="border-top-left-radius: var(--vz-border-radius) !important; border-top-right-radius: var(--vz-border-radius) !important;">

            <div class=" d-flex align-items-center justify-content-end">
                <h5 class=" flex-grow-1 fs-17 " style="padding-top: 0.5%;" i18n="@@">Note List</h5>


                <div *ngIf="securityPermissionTimelineCreateNote" class="flex-shrink-0 d-flex gap-1">

                    <button class="btn btn-success createFile-modal " (click)="newNote()">
                        <i class="ri-add-fill me-1 align-bottom"></i>
                        <span i18n="@@List_Base_Button_CreateNew"> Create New </span>
                    </button>
                </div>
            </div>
        </div>
        <div class="card-body"
            style="border-top-left-radius: var(--vz-border-radius) !important; border-top-right-radius: var(--vz-border-radius) !important;">
            <div class="row g-3" style="display:flex; justify-content: space-between;">
                <div class="col-12 col-lg-6">
                    <div class="d-flex align-items-center gap-2">
                        <div class="search-box flex-grow-1">
                            <input type="text" name="searchTerm" class="form-control search bg-light border-light"
                                placeholder="{{searchPlaceHolderText}}" [(ngModel)]="timeLineListService.searchTerm">
                            <i class="ri-search-line search-icon"></i>
                            <i *ngIf="timeLineListService.searchTerm"
                                class="mdi mdi-close-circle search-widget-icon search-widget-icon-close" style="font-size: 1rem;
                            position: absolute;
                            cursor: pointer;
                            right: 13px;
                            top: 0;
                            height: 100%;
                            display: flex;
                            align-items: center;
                            color: #878a99;" (click)="clearSearchTerm(timeLineListService)"></i>
                        </div>
                    </div>
                </div>
                <div class="col-lg-4 d-flex row mt-3">
                    <div class="col-12" [ngClass]="{ 'col-md-12': (!showTimeLineTypesDropdown)}">
                        <div *ngIf="showOwnerEntityDropdown">
                            <app-ng-select-layout-filter [placeHolderText]="'Select Status'" (statusChanged)="timeLineTypeFilter($event)" [items]="timelineTypeAvailableOptions" ></app-ng-select-layout-filter>
                        </div>
                    </div>
                    <div class="col-6" [ngClass]="{ 'col-md-12': (!showOwnerEntityDropdown)}">
                        <div *ngIf="showTimeLineTypesDropdown">
                            <app-ng-select-layout-filter [placeHolderText]="'Select Status'" (statusChanged)="timeLineOwnerEntityTypeFilter($event)" [items]="timelineOwnerEntityTypeAvailableOptions" ></app-ng-select-layout-filter>
                        </div>
                    </div>
                </div>
                <div *ngIf="securityPermissionTimelineCreateNote && !showTitle" class="col-auto" style="display: flex;
                flex-direction: row-reverse;">
                    <button class="btn btn-success createFile-modal " (click)="newNote()">
                        <i class="ri-add-fill me-1 align-bottom"></i>
                        <span i18n="@@List_Base_Button_CreateNew"> Create New </span>
                    </button>
                </div>
            </div>
        </div>

        <div class="card-body p-0">
            <div style="padding-right: 1rem; padding-left: 1rem; margin-bottom: 0; max-height: 60vh; overflow:auto;">
                <div class="table-responsive table-card " style="margin-bottom: 0; margin-top: 0; ">
                    <table class="table align-middle table-nowrap" style="margin-bottom: 0; ">
                        <thead class="text-muted table-light">
                            <tr>
                                <th scope="col" style="width: 50px;">
                                    <div class="form-check">
                                        <input class="form-check-input" type="checkbox" id="checkAll" value="option"
                                            [(ngModel)]="masterSelected"
                                            (change)="checkUncheckAll(timeLineListService,$event)">
                                    </div>
                                </th>
                                <th *ngIf="ownerType == enumOwnerType.Client || ownerType == enumOwnerType.All">
                                    <div class="d-flex">
                                        <span class="flex-grow-1 " i18n="@@">Client</span>
                                        <div class="flex-shrink-0 ">
                                            <div *ngIf='sortBy != 1 && sortBy != 2' class="bx bxs-sort-alt me-1"
                                                (click)="sort(1)"></div>
                                            <div *ngIf='sortBy == 1' class="bx bx-caret-up me-1" (click)="sort(2)">
                                            </div>
                                            <div *ngIf='sortBy == 2' class="bx bx-caret-down me-1" (click)="sort(0)">
                                            </div>
                                        </div>
                                    </div>
                                </th>
                                <th>
                                    <div class="d-flex">
                                        <span class="flex-grow-1 " i18n="@@">Time Spent</span>
                                        <div class="flex-shrink-0 ">
                                            <div *ngIf='sortBy != 3 && sortBy != 4' class="bx bxs-sort-alt me-1"
                                                (click)="sort(3)"></div>
                                            <div *ngIf='sortBy == 3' class="bx bx-caret-up me-1" (click)="sort(4)">
                                            </div>
                                            <div *ngIf='sortBy == 4' class="bx bx-caret-down me-1" (click)="sort(0)">
                                            </div>
                                        </div>
                                    </div>
                                </th>
                                <th>
                                    <div class="d-flex">
                                        <span class="flex-grow-1 " i18n="@@">Date Created</span>
                                        <div class="flex-shrink-0 ">
                                            <div *ngIf='sortBy != 7 && sortBy != 8' class="bx bxs-sort-alt me-1"
                                                (click)="sort(7)"></div>
                                            <div *ngIf='sortBy == 7' class="bx bx-caret-up me-1" (click)="sort(8)">
                                            </div>
                                            <div *ngIf='sortBy == 8' class="bx bx-caret-down me-1" (click)="sort(0)">
                                            </div>
                                        </div>
                                    </div>
                                </th>
                                <th>
                                    <div class="d-flex">
                                        <span class="flex-grow-1 " i18n="@@">Created By</span>
                                    </div>
                                </th>
                                <th>
                                    <div class="d-flex">
                                        <span class="flex-grow-1 " i18n="@@">Type</span>
                                        <div class="flex-shrink-0 ">
                                            <div *ngIf='sortBy != 5 && sortBy != 6' class="bx bxs-sort-alt me-1"
                                                (click)="sort(5)"></div>
                                            <div *ngIf='sortBy == 5' class="bx bx-caret-up me-1" (click)="sort(6)">
                                            </div>
                                            <div *ngIf='sortBy == 6' class="bx bx-caret-down me-1" (click)="sort(0)">
                                            </div>
                                        </div>
                                    </div>
                                </th>
                                <th>
                                    <div class="d-flex">
                                        <span class="flex-grow-1 " i18n="@@">Description</span>
                                    </div>
                                </th>
                                <th>
                                    <div class="d-flex">
                                        <span class="flex-grow-1 " i18n="@@">Action</span>
                                    </div>
                                </th>
                            </tr>
                        </thead>
                        <tbody class="list form-check-all">
                            <tr *ngFor="let data of listItems" id="i_{{data.id}}">
                                <th scope="row">
                                    <div class="form-check">
                                        <input class="form-check-input" type="checkbox" name="checkAll"
                                            style="cursor:pointer" value="{{data.id}}"
                                            (change)="onCheckboxChange(timeLineListService,$event)"
                                            [(ngModel)]="data.state">
                                    </div>
                                </th>
                                <td *ngIf="ownerType == enumOwnerType.Client || ownerType == enumOwnerType.All">
                                    <div *ngIf="data.clientBase && data.ownerEntityType==1"
                                        class="d-flex align-items-center" style="cursor:pointer"
                                        (click)="openClientModal(data.clientBase.id)">
                                        <div class="flex-shrink-0 gap-2">
                                            <img [src]="profilePhotoPNGTransform(data.clientBase.listPhoto)" alt=""
                                                class=" avatar-xs rounded-circle me-2">
                                        </div>

                                        <ngb-highlight [result]="data.clientBase.fullName"
                                            [term]="timeLineListService.searchTerm">
                                        </ngb-highlight>
                                    </div>

                                    <ngb-highlight *ngIf="data.ownerEntityType === undefined || data.ownerEntityType==0"
                                        [term]="timeLineListService.searchTerm" style="cursor:default">
                                    </ngb-highlight>
                                </td>
                                <td id="id_data.id" style="cursor:default">
                                    <ngb-highlight [result]='renameDataTimeSpent(data.timeSpent)'>
                                    </ngb-highlight>
                                </td>
                                <td>
                                    <span>
                                        {{dateRename(data.createdDate)}}
                                    </span>
                                </td>
                                <td>
                                    <div *ngIf="data.owner" class="d-flex align-items-center">
                                        <div class="flex-shrink-0 gap-2">
                                            <img [src]="profilePhotoPNGTransform(data.owner.listPhoto)" alt=""
                                                class=" avatar-xs rounded-circle me-2">
                                        </div>

                                        <ngb-highlight [result]="data.owner.fullName"
                                            [term]="timeLineListService.searchTerm">
                                        </ngb-highlight>
                                    </div>

                                    <ngb-highlight *ngIf="data.ownerEntityType === undefined || data.ownerEntityType==0"
                                        [term]="timeLineListService.searchTerm" style="cursor:default">
                                    </ngb-highlight>

                                </td>
                                <td>
                                    <ngb-highlight [result]="renameDataType(data.type)"
                                        [term]="timeLineListService.searchTerm">
                                    </ngb-highlight>
                                </td>
                                <td
                                    style="overflow: hidden; white-space: wrap !important; max-width: 30vw; text-overflow: ellipsis;">

                                    <div>
                                        {{data.name}} <span *ngIf="data.description">-</span> {{data.description}}
                                    </div>
                                </td>

                                <td>
                                    <div class=" d-flex ">
                                        <ul class="list-inline hstack gap-2 mb-0">
                                            <li class="list-inline-item">
                                                <div class="dropdown" ngbDropdown
                                                    style="z-index: 100;  position: static;">
                                                    <button [disabled]="submitted"
                                                        class="btn btn-soft-secondary btn-sm dropdown arrow-none"
                                                        type="button" data-bs-toggle="dropdown" aria-expanded="false"
                                                        ngbDropdownToggle>
                                                        <i class="ri-more-fill align-middle"></i>
                                                    </button>
                                                    <ul class="dropdown-menu " ngbDropdownMenu
                                                        style=" position: absolute; ">
                                                        <li
                                                            *ngIf="((data.type == enumTimeLineType.Note) && securityPermissionTimelineCreateNote )else elseViewButton">
                                                            <button [disabled]="submitted"
                                                                class="dropdown-item edit-item-btn"
                                                                style="cursor:pointer" data-bs-toggle="modal"
                                                                (click)="openNote(data, false)"><i
                                                                    class="ri-edit-line align-bottom me-2 text-muted"></i>
                                                                Edit</button>
                                                        </li>
                                                        <ng-template #elseViewButton>
                                                            <li>
                                                                <button [disabled]="submitted"
                                                                    class="dropdown-item edit-item-btn"
                                                                    style="cursor:pointer" data-bs-toggle="modal"
                                                                    (click)="openNote(data, true)"><i
                                                                        class="ri-eye-fill align-bottom me-2 text-muted"></i>
                                                                    View</button>
                                                            </li>
                                                        </ng-template>
                                                    </ul>
                                                </div>
                                            </li>
                                        </ul>
                                    </div>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>

        <div class=" card-body ">
            <div class="row justify-content-md-between align-items-md-center">
                <div class="col col-sm-6">
                    <div class="dataTables_info mb-2" id="tickets-table_info" role="status" aria-live="polite">
                        {{pagingInfo(timeLineListService)}}
                    </div>
                </div>
                <div class="col col-sm-6">
                    <div class="text-sm-right float-end listjs-pagination">
                        <ngb-pagination [collectionSize]="(total | async)!" [(page)]="timeLineListService.startIndex">
                            <ng-template ngbPaginationPages let-page let-pages="pages">
                                <li class="ngb-custom-pages-item" *ngIf="pages.length > 0">
                                    <div class="mb-3 d-flex flex-nowrap px-2">
                                        <label id="paginationInputLabel" for="paginationInput"
                                            class="col-form-label me-2 ms-1" i18n="@@Pagination_Text_Page">Page</label>
                                        <input #i type="text" inputmode="numeric" pattern="[0-9]*"
                                            class="form-control custom-pages-input" id="paginationInput"
                                            [value]="timeLineListService.startIndex"
                                            (keyup.enter)="selectPage(timeLineListService,i.value)"
                                            (blur)="selectPage(timeLineListService,i.value)"
                                            (input)="formatPageInput($any($event).target)"
                                            aria-labelledby="paginationInputLabel paginationDescription"
                                            style="text-align: center; width:3.5rem;" />
                                        <span id="paginationDescription" class="col-form-label text-nowrap px-2 ">
                                            <span i18n="@@Pagination_Text_Of">of</span> {{pages.length}}</span>
                                    </div>
                                </li>
                            </ng-template>
                        </ngb-pagination>
                    </div>
                </div>
            </div>
            <div *ngIf="isLoadingVal" id="elmLoader">
                <div class="spinner-border text-primary avatar-sm" role="status">
                    <span class="visually-hidden">Loading...</span>
                </div>
            </div>
        </div> -->
    </div>
</div>